import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=4d8a5e68&scoped=true"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"
import style0 from "./SendEmail.vue?vue&type=style&index=0&id=4d8a5e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a5e68",
  null
  
)

export default component.exports